// src/App.js
import React from 'react';
import { Shield, Lock, Globe, Code } from 'lucide-react';
import Chat from './components/Chat';
import ProjectAnalysis from './components/ProjectAnalysis';
import { Card, CardContent } from './components/ui/card';

function App() {
  return (
    <div className="min-h-screen bg-black text-gray-100">
      {/* Header */}
      <header className="bg-gradient-to-r from-pink-600 to-purple-800 p-4">
        <div className="container mx-auto flex items-center gap-2">
          <Shield className="w-8 h-8" />
          <h1 className="text-2xl font-bold">Sentinel Protocol</h1>
        </div>
      </header>

      {/* Logo Section */}
      <div className="container mx-auto py-8 flex justify-center">
        <img 
          src="/trenchlogo.webp" 
          alt="Sentionel Protocol Logo" 
          className="w-64 h-64 object-contain"
        />
      </div>

      {/* Main Content */}
      <div className="container mx-auto p-4 grid grid-cols-1 lg:grid-cols-2 gap-6">
        <Chat />
        <ProjectAnalysis />
      </div>

      {/* Project Information */}
      <div className="container mx-auto p-4 mt-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <Card className="bg-gray-900 border-pink-500">
            <CardContent className="p-6">
              <div className="flex items-center gap-2 mb-4">
                <Lock className="text-pink-500 w-6 h-6" />
                <h3 className="text-xl font-bold">Security First</h3>
              </div>
              <p className="text-gray-300">
                Sentionel Protocol leverages advanced AI to provide real-time security analysis of blockchain projects. 
                Our system continuously monitors for potential threats and vulnerabilities, ensuring your investments 
                are protected through comprehensive risk assessment.
              </p>
            </CardContent>
          </Card>

          <Card className="bg-gray-900 border-purple-500">
            <CardContent className="p-6">
              <div className="flex items-center gap-2 mb-4">
                <Globe className="text-purple-500 w-6 h-6" />
                <h3 className="text-xl font-bold">Global Analysis</h3>
              </div>
              <p className="text-gray-300">
                Access comprehensive project analysis across multiple blockchains and protocols. 
                Our platform provides detailed insights into tokenomics, team credentials, 
                smart contract security, and market dynamics to help you make informed decisions.
              </p>
            </CardContent>
          </Card>

          <Card className="bg-gray-900 border-pink-500">
            <CardContent className="p-6">
              <div className="flex items-center gap-2 mb-4">
                <Code className="text-pink-500 w-6 h-6" />
                <h3 className="text-xl font-bold">Smart Contract Audit</h3>
              </div>
              <p className="text-gray-300">
                Our AI-powered system performs deep analysis of smart contract code, 
                identifying potential vulnerabilities and security risks before they can be exploited. 
                Get detailed reports and recommendations for improving contract security.
              </p>
            </CardContent>
          </Card>
        </div>
      </div>

      {/* Footer spacing */}
      <div className="h-16"></div>
    </div>
  );
}

export default App;